import React from 'react';

interface MSpacerProps {
  mt?: number; // marginTop in px
}

const MSpacer: React.FC<MSpacerProps> = ({ mt = 64 }) => (
  <div style={{ marginTop: mt }} />
);

export default MSpacer;
